import React from 'react'
import aiImg from '../../../assets/images/ai-avatar.svg'
import { StyledMessage } from './NewOnboarding.styles'

const BotMessage = ({ messages, children }) => (
    <StyledMessage>
        <div className='img-holder'>
            <img src={aiImg} alt='aiImg' />
        </div>
        <div className='content'>
            <div className='text-holder'>
                {messages?.map((message, messageIndex) => (
                    <span key={messageIndex} className='text'>{message}</span>
                ))}
            </div>
            {children}
        </div>
    </StyledMessage>
)

export default BotMessage
